import type { ContentHubAsset } from '@cdf/api-client-react';

/** Only known native content routes and opaque record identity enter a resume URL. */
export function contentAssetDestination(asset: Pick<ContentHubAsset, 'id' | 'kind'>) {
  const path = asset.kind === 'lead_magnet' ? '/content-hub/lead-magnet'
    : asset.kind === 'operation' ? '/content-hub/operations'
    : '/content-hub/authority';
  const params = new URLSearchParams({ assetId: asset.id });
  if (asset.kind === 'faq' || asset.kind === 'case_study') params.set('kind', asset.kind);
  return path + '?' + params.toString();
}
